// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tag_wrapper__1Iag3","contrast":"Tag_contrast__2p7Zg"};